export default __webpack_public_path__ + "static/media/resume.6e449fed.pdf";